import { createContext } from "react";

export const UpdateReferantContext = createContext({
  isLoading: false,
  formData: {
    referant_name: "",
  },
  onValueChange: (slug: string) => function (value: any) {},
  submitForm: function () {},
  errorState: {
    referant_name: { state: false, msg: "" },
  },
});
